import { useState } from 'react';
import { CreateNotificationRuleDialog } from '@/features/notification-rules/components/create-notification-rule/create-notification-rule-dialog.tsx';
import CreateNotificationRuleForm from './create-notification-rule-form';

export const CreateNotificationRule = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <CreateNotificationRuleDialog
      isDialogOpen={isDialogOpen}
      setIsDialogOpen={setIsDialogOpen}
    >
      <CreateNotificationRuleForm onClose={handleDialogClose} />
    </CreateNotificationRuleDialog>
  );
};
